import React from 'react'
const VersionIcon = () => {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_16185_3973)'>
        <mask id='mask0_16185_3973' maskUnits='userSpaceOnUse' x='0' y='-1' width='21' height='21'>
          <path d='M0.195312 -0.152342H20.1953V19.8477H0.195312V-0.152342Z' fill='white' />
        </mask>
        <g mask='url(#mask0_16185_3973)'>
          <path
            d='M14.5859 5.4557C13.8924 5.4557 13.3307 4.89371 13.3307 4.20051V1.68945C13.3307 1.35684 13.1989 1.0377 12.9636 0.802345C12.7282 0.566994 12.4082 0.434884 12.0755 0.434884H8.30988C7.61641 0.434884 7.05469 0.996876 7.05469 1.69008V12.987C7.05469 13.6802 7.61641 14.2422 8.30988 14.2422H17.0964C17.429 14.2422 17.7491 14.11 17.9844 13.8744C18.2197 13.6391 18.3515 13.3199 18.3515 12.987V6.7109C18.3515 6.37797 18.2197 6.05883 17.9844 5.82348C17.7491 5.58781 17.429 5.4557 17.0964 5.4557H14.5859Z'
            stroke='#402080'
            stroke-width='1.17187'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M15.8437 14.2415H8.31246C7.97984 14.2415 7.65977 14.1094 7.42445 13.8738C7.18906 13.6384 7.05727 13.3193 7.05727 12.9863V2.94465H5.80207C5.46941 2.94465 5.14938 3.07676 4.91402 3.31242C4.67867 3.54777 4.54688 3.86692 4.54688 4.19985V15.4967C4.54688 16.1899 5.10859 16.752 5.80207 16.752H14.5885C15.282 16.752 15.8437 16.1899 15.8437 15.4967V14.2415Z'
            stroke='#402080'
            stroke-width='1.17187'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M13.332 16.7513H5.80074C5.46813 16.7513 5.14805 16.6192 4.91273 16.3835C4.67734 16.1482 4.54555 15.829 4.54555 15.4961V5.45441H3.29035C2.9577 5.45441 2.63766 5.58652 2.40227 5.82219C2.16695 6.05754 2.03516 6.37668 2.03516 6.70961V18.0065C2.03516 18.6997 2.59687 19.2617 3.29035 19.2617H12.0768C12.7703 19.2617 13.332 18.6997 13.332 18.0065V16.7513Z'
            stroke='#402080'
            stroke-width='1.17187'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M18.3541 6.71094C18.3541 5.9073 18.0341 5.1366 17.4661 4.56828C16.553 3.65387 15.1345 2.23676 14.2214 1.32234C13.6534 0.754024 12.8814 0.434883 12.0781 0.434883C12.4108 0.434883 12.7308 0.566992 12.9661 0.802344C13.2015 1.03773 13.3333 1.35688 13.3333 1.68949V4.20051C13.3333 4.89371 13.895 5.45574 14.5886 5.45574H17.0989C17.4316 5.45574 17.7516 5.58785 17.987 5.8232C18.2223 6.05855 18.3541 6.3777 18.3541 6.71031V6.71094Z'
            stroke='#402080'
            stroke-width='1.17187'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M10.8203 9.84766L12.0755 11.7305L14.5859 7.96484'
            stroke='#402080'
            stroke-width='1.17187'
            stroke-miterlimit='10'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_16185_3973'>
          <rect width='20' height='20' fill='white' transform='translate(0.195312 0.134766)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default VersionIcon
